import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AuthGuard } from './auth/auth.guard';
import { LoginComponent } from './auth/login/login.component';
import { FormCotizacionComponent } from './cotizador/form-cotizacion/components/form-cotizacion.component';

const routes: Routes = [
    { path: '', redirectTo: '/cotizacion',pathMatch: 'full'},
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'cotizacion',
        loadChildren: () => import('./cotizador/form-cotizacion/form-cotizacion.module').then(m => m.FormCotizacionModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'cotizaciones/:idProcedure/:idProducto/:idCategoria/:idSubMarca/:descriptionIndex',
        loadChildren: () => import('./cotizador/cotizaciones/cotizaciones.module').then(m => m.CotizacionesModule),
        canActivate: [AuthGuard]
    },
    {
        path:  'pago/:idProcedure/:idAseguradora/:idCotizacion/:idTypeUser',
        loadChildren: () => import('./cotizador/form-pago/form-pago.module').then(m => m.FormPagoModule)
    },
    {
        path: 'poliza/:idProcedure/:idAseguradora/:idCotizacion',
        loadChildren: () => import('./cotizador/emision-poliza/emision-poliza.module').
        then(m => m.EmisionPolizaModule)
    },
    {
        path: 'pdf-poliza/:idProcedure/:idAseguradora/:idCotizacion/:idPoliza',
        loadChildren: () => import('./cotizador/pdf-poliza/pdf-poliza.module').
        then(m => m.PdfPolizaModule)
    },
    {
        path: '**',
        component: PageNotFoundComponent,
        canActivate: [AuthGuard]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        scrollPositionRestoration: 'enabled'
    })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
